/* global translations */
import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import ImageSvg from '../image/ImageSvg';

const VerificationBadge = (props) => {
  const { tooltipRightSide } = props;

  const onClick = (e) => {
    e.preventDefault();

    window.location.href = '/verification';
  };

  return (
    <span
      role="presentation"
      onClick={onClick}
      onKeyDown={onClick}
      className={`memberName-verified tooltip${tooltipRightSide ? ' tooltip--rightSide' : ''}`}
      data-tooltip={get(translations, 'txt: Verificēts profils', '')}
      data-post="true"
    >
      <span className="btn-static">
        <span className="vcenter">
          <span className="vcenter-inner">
            <ImageSvg
              svg="icon-check-2"
              iconClass="icon--blue icon--verification"
            />
          </span>
        </span>
      </span>
    </span>
  );
};

VerificationBadge.propTypes = {
  tooltipRightSide: PropTypes.bool,
};

VerificationBadge.defaultProps = {
  tooltipRightSide: false,
};

export default VerificationBadge;
